<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	interface Props {
		config: BrandConfig;
		className?: string;
		title?: string;
		items?: string[];
	}

	let {
		config,
		className = '',
		title,
		items
	}: Props = $props();

	// Use custom title or default with brand configuration
	const benefitsTitle = title || config.landingPage?.whatYouGet?.title || 'What You\'ll Get:';

	// Use custom items or brand configuration or fallback
	const benefitsItems = items || config.landingPage?.whatYouGet?.items || [
		`✓ Immediate access to ${config.productName}`,
		'✓ Exclusive content and resources',
		'✓ Community access and support',
		'✓ Regular updates and new features'
	];
</script>

<div class="landing-benefits {className}">
	<h3>{benefitsTitle}</h3>
	<ul class="benefits-list">
		{#each benefitsItems as item}
			<li>{item}</li>
		{/each}
	</ul>
</div>

<style>
	.landing-benefits {
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(10px);
		border-radius: 12px;
		padding: 1rem 2rem 1.5rem 2rem;
		border: 1px solid rgba(255, 255, 255, 0.2);
	}

	.landing-benefits h3 {
		font-size: 1.5rem;
		margin-top: 0.5rem !important;
		margin-bottom: 0.5rem;
		color: white;
	}

	.benefits-list {
		list-style: none;
		padding: 0;
		margin: 0;
		text-align: left;
	}

	.benefits-list li {
		padding: 0.5rem 0;
		font-size: 1.1rem;
		opacity: 0.9;
	}

	@media (max-width: 768px) {
		.landing-benefits {
			padding: 1.5rem;
		}
	}
</style>
